// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var confirmationScreenData = createSlice({
    name: "confirmationScreenData",
    initialState: initialState,
    reducers: {
        setConfirmationScreenData: function (state, action) {
            state[action.payload.electionId] = action.payload.confirmationScreenData;
            return state;
        },
    },
});
export var setConfirmationScreenData = confirmationScreenData.actions.setConfirmationScreenData;
export var selectConfirmationScreenData = function (electionId) { return function (state) {
    return state.confirmationScreenData[electionId];
}; };
export default confirmationScreenData.reducer;
